export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "KES", symbol: "KSh ", name: "Kenyan Shilling" },
  { code: "GHS", symbol: "GH₵", name: "Ghanaian Cedi" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "XOF", symbol: "CFA ", name: "West African CFA Franc" },
  { code: "EGP", symbol: "E£", name: "Egyptian Pound" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "AED", symbol: "AED ", name: "UAE Dirham" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
];

export const curSymbol = (code) => CURRENCIES.find((c) => c.code === (code || "USD"))?.symbol || "$";

// ---- shopper-side display currency (set from the signup country, auto-detect, or the header switcher) ----
const _local = { code: null, rates: null };
try {
  _local.code = localStorage.getItem("vsk_view_currency") || null;
  _local.rates = JSON.parse(localStorage.getItem("vsk_view_rates") || "null");
} catch { /* ignore */ }
if (typeof window !== "undefined") window.addEventListener("vsk-currency", (e) => { _local.code = e.detail || null; });

export const setViewRates = (rates) => {
  if (!rates || typeof rates !== "object") return;
  _local.rates = rates;
  try { localStorage.setItem("vsk_view_rates", JSON.stringify(rates)); } catch { /* ignore */ }
};
export const setViewCurrency = (code) => {
  _local.code = code || null;
  try { code ? localStorage.setItem("vsk_view_currency", code) : localStorage.removeItem("vsk_view_currency"); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("vsk-currency", { detail: code || null }));
};
export const viewCurrency = () => _local.code;
export const viewRates = () => _local.rates;

const fmtIntl = (v, code) => {
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: code, maximumFractionDigits: 2 }).format(v); }
  catch { return `${code} ${v.toLocaleString(undefined, { maximumFractionDigits: 2 })}`; }
};

/** Converts into the shopper's display currency when known and different; "≈" marks a converted amount. */
export const fmtPrice = (amount, code = "USD") => {
  const base = `${curSymbol(code)}${Number(amount || 0).toFixed(2)}`;
  const to = _local.code, r = _local.rates;
  if (!to || to === code || !r || !r[code] || !r[to]) return base;
  return `≈${fmtIntl((Number(amount || 0) / r[code]) * r[to], to)}`;
};

const TZ_CURRENCY = {
  "Africa/Lagos": "NGN",
  "Africa/Nairobi": "KES",
  "Africa/Accra": "GHS",
  "Africa/Johannesburg": "ZAR",
  "Africa/Maseru": "ZAR",
  "Africa/Mbabane": "ZAR",
  "Africa/Cairo": "EGP",
  "Africa/Dakar": "XOF",
  "Africa/Abidjan": "XOF",
  "Africa/Bamako": "XOF",
  "Africa/Ouagadougou": "XOF",
  "Africa/Niamey": "XOF",
  "Africa/Lome": "XOF",
  "Africa/Porto-Novo": "XOF",
  "Asia/Kolkata": "INR",
  "Asia/Calcutta": "INR",
  "Asia/Dubai": "AED",
  "Asia/Shanghai": "CNY",
  "Asia/Urumqi": "CNY",
  "Europe/London": "GBP",
};

const REGION_CURRENCY = {
  NG: "NGN", KE: "KES", GH: "GHS", ZA: "ZAR", EG: "EGP", IN: "INR",
  AE: "AED", CN: "CNY", GB: "GBP",
  SN: "XOF", CI: "XOF", ML: "XOF", BF: "XOF", NE: "XOF", TG: "XOF", BJ: "XOF",
  DE: "EUR", FR: "EUR", ES: "EUR", IT: "EUR", NL: "EUR", PT: "EUR", IE: "EUR",
  BE: "EUR", AT: "EUR", FI: "EUR", GR: "EUR",
};

const EURO_TZ_PREFIXES = ["Europe/Berlin", "Europe/Paris", "Europe/Madrid", "Europe/Rome",
  "Europe/Amsterdam", "Europe/Lisbon", "Europe/Dublin", "Europe/Brussels", "Europe/Vienna",
  "Europe/Helsinki", "Europe/Athens"];

export const detectLocalCurrency = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (TZ_CURRENCY[tz]) return TZ_CURRENCY[tz];
    if (EURO_TZ_PREFIXES.includes(tz)) return "EUR";
    const lang = navigator.language || "";
    const region = lang.split("-")[1]?.toUpperCase();
    if (region && REGION_CURRENCY[region]) return REGION_CURRENCY[region];
  } catch { /* ignore */ }
  return "USD";
};
